<template>
  <div class="app-header">
    <!-- <h1><a class="navbar-brand" href="#" @click.prevent="goTo('FeaturesList')"><img src="http://eventhud.com.br/images/iv/eventhud-main-logo-white.png" alt=""></a></h1> -->

    <!-- <h1>EventHud</h1> -->
    <nav class="navbar navbar-expand-lg bg-eh">
      <a class="navbar-brand" href="#" @click.prevent="goTo('FeaturesList')"><img src="http://eventhud.com.br/images/iv/eventhud-main-logo-white.png" alt=""></a>

      <div class="navbar" id="navbarNav">
        <ul class="nav navbar-nav ml-auto w-100 justify-content-end">
          <b-dropdown v-if="token" right="true" id="ddown1" text="MENU" variant="success" class="justify-content-end m-sm-12 bg-eh">
          <b-dropdown-item @click.prevent="goTo('FeaturesList')">Atividades</b-dropdown-item>
          <b-dropdown-item @click.prevent="goTo('ActivitiesList')">Minhas Atividades</b-dropdown-item>
          <b-dropdown-item @click.prevent="goTo('AccountManage')">Minha conta</b-dropdown-item>
          <b-dropdown-item @click.prevent="signOut">Sair</b-dropdown-item>
        </b-dropdown>
        </ul>
      </div>
    </nav>

    <!-- <h1>EventHud</h1> -->
    <!-- <nav class="navbar navbar-expand-lg bg-eh">
      <a class="navbar-brand" href="#" @click.prevent="goTo('FeaturesList')"><img src="http://eventhud.com.br/images/iv/eventhud-main-logo-white.png" alt=""></a>
      <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarNav" aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
        <span class="navbar-toggler-icon"></span>
      </button>
      <div class="collapse navbar-collapse" id="navbarNav">
        <ul class="nav navbar-nav ml-auto w-100 justify-content-end">
          <li class="nav-item active">
            <a class="nav-link" href="#" @click.prevent="goTo('FeaturesList')" style="color:#FFF" v-if="token">Atividades</a>
          </li>
          <li class="nav-item active">
            <a class="nav-link" href="#" @click.prevent="goTo('ActivitiesList')" style="color:#FFF" v-if="token">Minhas Atividades</a>
          </li>
          <li class="nav-item active">
            <a class="nav-link" href="#" @click.prevent="goTo('AccountManage')" style="color:#FFF" v-if="token">Minha conta</a>
          </li>
          <li class="nav-item">
            <a class="nav-link" href="#" @click.prevent="signOut" style="color:#FFF" v-if="token">Sair</a>
          </li>
        </ul>
      </div> -->

    <!-- </nav> -->

  </div>
</template>

<script>
  export default {
    // el
    // name
    // parent
    // functional
    // delimiters
    // comments
    // components
    // directives
    // filters
    // extends
    // mixins
    // inheritAttrs
    // model
    // props: {
    //   status: {
    //     type: Number,
    //     // type: String,
    //     // type: Boolean,
    //     // type: Function,
    //     // type: Object,
    //     // type: Array,
    //     // type: Symbol
    //     default: 1,
    //     required: false,
    //     validator(value) {
    //       return value >= 0;
    //     },
    //   },
    // },
    data() {
      return {
        token: localStorage.getItem('token'),
      };
    },
    // computed
    // watch
    // beforeCreate() { },
    // created() { },
    // beforeMount() { },
    // mounted() { },
    // beforeUpdate() { },
    // updated() { },
    // activated() { },
    // deactivated() { },
    // beforeDestroy() { },
    // destroyed() { },
    methods: {
      signOut() {
        localStorage.removeItem('token');
        localStorage.removeItem('user');
        localStorage.removeItem('features');
        this.$router.push({ name: 'SignIn' });
      },
      goTo(route) {
        this.$router.push({ name: route });
      },
    },
    // template/render
    // renderError
  };
</script>

<style scoped>
/* .sign-out {
  margin: 2rem 10vw;
} */

.bg-eh {
  background-color: #25984c;
  width: 100%;
}

.navbar {

}

.app-header {
  display: flex;
}

.app-header h1 {
  margin-right: 10px;
}
</style>




// WEBPACK FOOTER //
// src/components/AppHeader.vue